import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { FormProvider } from "react-hook-form";
import { getSchemaPathRequirementMap } from "./_internal/getSchemaPathRequirementMap.js";
const FormManagerContext = /*#__PURE__*/ createContext({});
const FormManagerProvider = ({ schema, ...props })=>{
    const value = useMemo(()=>({
            schemaPathRequirementMap: schema ? getSchemaPathRequirementMap(schema) : void 0
        }), [
        schema
    ]);
    return /*#__PURE__*/ jsx(FormManagerContext.Provider, {
        value: value,
        children: /*#__PURE__*/ jsx(FormProvider, {
            ...props
        })
    });
};
const useFormManager = ()=>useContext(FormManagerContext);
export { FormManagerProvider, useFormManager };
